<re-side-menu class="shrink-0 overflow-x-hidden overflow-y-auto">
</re-side-menu>

<div class="main-content flex min-h-0 w-full min-w-0 grow overflow-hidden p-4">
  <router-outlet />
</div>
